import { Box, Stack, useTheme } from "@mui/material"
import { ReactComponent as IconProfit } from '@/views/assets/icons/profit.svg'
import { ReactComponent as IconLoss } from '@/views/assets/icons/loss.svg'
import TypographyElement, { FontSizeTypographyElement, FontWeightTypographyElement } from "@/views/elements/typography/TypographyElement"
import ViewNumberFormat from "@/views/elements/Inputs/ViewNumberFormat"

type Props = { 
    data: number | string;
    fontSizeElement?: FontSizeTypographyElement;
    fontWeightElement?: FontWeightTypographyElement;
}

export default function RenderProfitLoss({ data, fontSizeElement = '18px', fontWeightElement = 700 }: Props) {
    const theme = useTheme()
    const value: number = Number.parseFloat(Number.parseFloat(data?.toString()).toFixed(2))

    return (
        <Box>
            {(value <= 0) && (
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <IconLoss />
                    <TypographyElement FontSizeElement={fontSizeElement} FontWeightElement={fontWeightElement} ColorElement="down" >
                        <ViewNumberFormat displayType='text' isPercentage color="inherit" fontWeightElement={fontWeightElement} value={value}></ViewNumberFormat>
                    </TypographyElement>

                </Stack>
            )}

            {(value > 0) && (
                <Stack direction={'row'} spacing={1} alignItems={'center'}>
                    <IconProfit />
                    <TypographyElement FontSizeElement={fontSizeElement} FontWeightElement={fontWeightElement} ColorElement="up">
                        +<ViewNumberFormat displayType='text' isPercentage color="inherit" fontWeightElement={fontWeightElement} value={value}></ViewNumberFormat>
                    </TypographyElement>

                </Stack>
            )}
        </Box>
    )
}